module.exports = __webpack_public_path__ + "static/media/tradicional_v2.f61575be.png";